import { globalHeaders } from "../global-headers";

export type FrontendConfig = {
	sentryDsn: string | null;
	environment: string | null;
	release: string | null;
	/** A genuine reply newer than this many days marks a person as a warm contact. */
	warmContactReplyWindowDays: number | null;
	/** Non-prod instance with the import-from-prod admin feature enabled. */
	prodImportEnabled?: boolean;
	/** Cloud sessions may upload UI mockups; off means plans never get one. */
	workflowMockupsEnabled?: boolean;
};

const endpoint = "/api/v2/frontend-config/";

export const fetchFrontendConfig = async (): Promise<FrontendConfig> => {
	const response = await fetch(endpoint, {
		headers: globalHeaders,
	});

	if (!response.ok) {
		throw new Error(`Failed to load frontend config: ${response.status}`);
	}

	return (await response.json()) as FrontendConfig;
};
